// Идентификатор вкладки и текущий маршрут для склейки запросов Контроль-API
// (lograge → Kibana) с целями Метрики (business_apps#1465).
//
// Идентификатор живёт в sessionStorage: у каждой вкладки свой, переживает
// перезагрузку и SSO-круг, исчезает при закрытии вкладки и при logout
// (там делается sessionStorage.clear()).

const STORAGE_KEY = 'control_request_session'
const ID_BYTES = 10
const MAX_ROUTE_LENGTH = 128

const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC_SEGMENT = /^\d+$/

let cachedId = null

const randomHex = () => {
  const bytes = new Uint8Array(ID_BYTES)
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

const readStored = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY)
  } catch (error) {
    return null
  }
}

const writeStored = (value) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value)
  } catch (error) {
    // приватный режим / запрет storage — живём с id в памяти вкладки
  }
}

export const getRequestSessionId = () => {
  if (cachedId) return cachedId
  if (typeof window === 'undefined') return null

  const stored = readStored()
  if (stored) {
    cachedId = stored
    return cachedId
  }

  cachedId = randomHex()
  writeStored(cachedId)
  return cachedId
}

// Только для тестов: сбросить кэш модуля.
export const resetRequestSessionId = () => {
  cachedId = null
}

// `/e/6f1c…-…` → `/e/:uuid`, `/orders/123` → `/orders/:id`, хвостовой слэш
// и query отбрасываются. Нужен для агрегаций в Kibana без взрыва кардинальности.
export const normalizeRoute = (pathname = '') => {
  const clean = String(pathname).split('?')[0].split('#')[0]
  const segments = clean
    .split('/')
    .filter(Boolean)
    .map((segment) => {
      if (UUID_SEGMENT.test(segment)) return ':uuid'
      if (NUMERIC_SEGMENT.test(segment)) return ':id'
      return segment
    })
  const route = `/${segments.join('/')}`
  return route.slice(0, MAX_ROUTE_LENGTH)
}

export const currentRoute = () => {
  if (typeof window === 'undefined') return null
  return normalizeRoute(window.location.pathname)
}
